export type NewsCategory = "热点" | "影评" | "访谈" | "行业";

export interface NewsBlock {
  type: "p" | "h3" | "img";
  text?: string;
  src?: string;
  caption?: string;
}

export interface NewsItem {
  id: string;
  title: string;
  excerpt: string;
  category: NewsCategory;
  author: string;
  date: string;
  cover: string;
  blocks: NewsBlock[];
  relatedTitleIds: string[];
}

export const newsCategories: NewsCategory[] = ["热点", "影评", "访谈", "行业"];

export const newsList: NewsItem[] = [
  {
    id: "deep-sea-echo-record",
    title: "《深海回声》票房破十二亿，深海题材为何突然被看见",
    excerpt:
      "上映第四周，《深海回声》凭口碑逆跌，成为今年最意外的黑马。我们和三位观众聊了聊，他们为什么愿意二刷一部没有特效奇观的悬疑片。",
    category: "热点",
    author: "编辑部 沈迟",
    date: "2025-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20cinema%20news%20cover%20showing%20a%20dark%20blue%20underwater%20theater%20hall%20with%20rows%20of%20empty%20seats%20and%20a%20glowing%20screen%2C%20moody%20navy%20and%20teal%20palette%2C%20no%20text%2C%20premium%20magazine%20photography&width=1200&height=675&seq=news-01&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "上映第四周，《深海回声》完成了一次几乎不可能的逆跌。没有大规模宣发，没有流量演员，它靠着一句“看到最后十分钟你会想再看一遍”，在工作日的午夜场上座率超过了同档期的所有新片。",
      },
      {
        type: "p",
        text: "影片的核心并不复杂：一支科考队在万米海沟录到一段低频回声，随后发现这段声音与二十年前失踪的科考船日志高度吻合。导演沈牧之把大量镜头留给了黑暗与静默，让观众自己听见那些没有被说出口的部分。",
      },
      { type: "h3", text: "观众在寻找什么" },
      {
        type: "p",
        text: "在我们的随机采访中，超过一半的观众提到了“耐心”这个词。有人说，这是今年第一部不急着解释自己的电影；也有人说，走出影院之后才意识到，真正让人不安的不是海沟，而是那些被选择性遗忘的记录。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20deep%20sea%20research%20vessel%20deck%20at%20night%20with%20blue%20work%20lights%20and%20rough%20dark%20water%20below%2C%20rain%20and%20mist%2C%20atmospheric%20and%20restrained%2C%20no%20text&width=1000&height=560&seq=news-01-b&orientation=landscape",
        caption: "影片中大量采用实景拍摄，海上段落几乎没有使用绿幕。",
      },
      {
        type: "p",
        text: "发行方透露，影片的排片从首日的 8.4% 已经提升到 21%，并将在下周增加杜比版本。对一部中小成本悬疑片来说，这个数字本身就是一个信号：观众的判断正在变得越来越独立于宣传声量。",
      },
    ],
    relatedTitleIds: ["harbor-in-fog", "the-man-in-the-mirror", "silent-testimony"],
  },
  {
    id: "long-night-review",
    title: "影评｜《长夜将至》：一场雨，困住了四个人和一座城",
    excerpt: "区朗生把整部电影压进一个断电的夜晚。它不急着抓凶手，反而更在意每个人在天亮前如何与自己和解。",
    category: "影评",
    author: "特约影评人 何岸",
    date: "2025-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=Noir%20editorial%20still%20of%20a%20rain%20soaked%20crossroad%20at%20night%20with%20a%20single%20street%20lamp%20and%20neon%20sign%20reflections%20on%20the%20wet%20road%2C%20deep%20blue%20and%20amber%20palette%2C%20no%20text&width=1200&height=675&seq=news-02&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "《长夜将至》有一个非常大胆的开场：整整七分钟没有一句台词。雨、断电的街区、便利店冷柜的嗡鸣，构成了这部电影真正的旁白。",
      },
      {
        type: "h3",
        text: "三个人的同一桩罪" ,
      },
      {
        type: "p",
        text: "影片把叙事切成三段，每一段都由不同的人讲述同一个夜晚。观众被迫反复回到同一个路口，看着细节一点点改变：伞的位置、车灯的方向、谁先开口。区朗生没有给出标准答案，他只是让每个人物都拥有一次自洽的机会。",
      },
      {
        type: "p",
        text: "这也是影片最动人的地方。它表面上是犯罪类型片，内里却是一部关于“被误解的人如何继续生活”的作品。结尾那个长达两分钟的固定镜头，几乎没有动作，却让人不敢呼吸。",
      },
      { type: "h3", text: "值得二刷的细节" },
      {
        type: "p",
        text: "留意第一次出现的行车记录仪画面：左下角的时间戳与后面两段并不一致。这个只有两秒的镜头，是全片最重要的钥匙。",
      },
    ],
    relatedTitleIds: ["long-night-coming", "zero-hour-operation", "dark-river-trail"],
  },
  {
    id: "director-interview-shen",
    title: "访谈｜沈牧之：我拍的不是悬疑，是人与记忆的拉扯",
    excerpt: "《深海回声》导演谈创作缘起、声音设计，以及为什么他坚持在片尾保留三十秒的静默。",
    category: "访谈",
    author: "编辑部 林一",
    date: "2025-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20scene%20of%20an%20empty%20director%20chair%20and%20monitor%20on%20a%20dim%20film%20set%20with%20blue%20set%20lights%20and%20cables%2C%20quiet%20atmospheric%20mood%2C%20no%20people%2C%20no%20text&width=1200&height=675&seq=news-03&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "采访约在一间录音棚。沈牧之到得很早，正在听一段水下录音。他说，这段声音是全片第一个被确定下来的东西，剧本反而是后来才写的。",
      },
      { type: "h3", text: "关于声音" },
      {
        type: "p",
        text: "“我们习惯用画面解释一切，但海不是这样的。海给你的是压力，是一种你听不清但知道它在的声音。”为此，团队在真实海沟录了十九天，最终只用了四分半钟的素材。",
      },
      { type: "h3", text: "关于那三十秒静默" },
      {
        type: "p",
        text: "片尾字幕前的三十秒黑屏，是导演坚持保留的。“我希望观众在离开之前，有机会自己想一遍。如果那三十秒被剪掉，这部电影就变成了一个答案，而不是一个问题。”",
      },
      {
        type: "p",
        text: "谈到下一部作品，他只说了一句：还是关于记忆，但这次不在水里。",
      },
    ],
    relatedTitleIds: ["deep-sea-echo", "stardust-traveler", "foggy-capital-files"],
  },
  {
    id: "autumn-lineup-2025",
    title: "2025 秋冬剧集前瞻：十二部值得留意的作品",
    excerpt: "从刑侦续作到东方奇幻，我们按题材整理了本季最值得关注的十二部剧集，并标注了各自的看点与风险。",
    category: "行业",
    author: "编辑部 周迟",
    date: "2025-10-03",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20photograph%20of%20a%20wall%20of%20blank%20movie%20poster%20frames%20in%20a%20dark%20gallery%20space%20with%20warm%20spotlights%2C%20deep%20navy%20walls%2C%20no%20text%2C%20clean%20minimal%20composition&width=1200&height=675&seq=news-04&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "今年的秋冬档有一个明显的趋势：短剧集继续增加，八到十二集的体量成为平台主推。对观众而言这意味着更紧凑的叙事，对创作者而言则意味着每一个镜头都必须有意义。",
      },
      { type: "h3", text: "三个值得关注的信号" },
      {
        type: "p",
        text: "第一，类型融合更加普遍。刑侦剧开始大量引入家庭与年代元素，奇幻剧则更愿意花时间搭建世界观而不是堆砌特效。第二，演员选择趋于“适配”而非“热度”。第三，平台开始为单集提供独立的导演剪辑版本。",
      },
      { type: "h3", text: "必看清单" },
      {
        type: "p",
        text: "《星际前哨》第二季、《雾都档案》衍生篇、《二十四小时急诊》新一季都将在本季上线。我们的建议是：先看预告片的声音设计，那往往比画面更能说明一部剧的完成度。",
      },
    ],
    relatedTitleIds: ["interstellar-outpost", "foggy-capital-files", "twenty-four-hour-er"],
  },
  {
    id: "city-glimmer-review",
    title: "影评｜《城市微光》的温柔，是不动声色的",
    excerpt: "它没有把都市生活拍成一场竞赛，而是拍成了四个住在同一栋楼里的人，如何共享一段沉默。",
    category: "影评",
    author: "特约影评人 苏禾",
    date: "2025-09-27",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20night%20photograph%20of%20a%20city%20apartment%20rooftop%20with%20string%20lights%20and%20a%20view%20of%20lit%20windows%20in%20distant%20buildings%2C%20deep%20blue%20sky%20and%20amber%20glow%2C%20no%20text&width=1200&height=675&seq=news-05&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "《城市微光》最难得的一点，是它愿意让角色沉默。四个人在同一部坏掉的电梯前相遇，谁也不说话，镜头停在那里整整四十秒。",
      },
      {
        type: "p",
        text: "这部剧没有把“奋斗”当成唯一正确的答案。它更关心的是：当你加班到凌晨，楼下便利店的灯还亮着，这件事本身是否已经足够。",
      },
      { type: "h3", text: "表演的克制" },
      {
        type: "p",
        text: "苏黎饰演的角色几乎没有情绪爆发戏，所有的转折都发生在眼神和停顿里。这种处理方式在国产都市剧中并不常见，也让整部剧的气质更接近一部散文。",
      },
    ],
    relatedTitleIds: ["city-glimmer", "old-days-in-the-hill-city", "summer-screening-room"],
  },
  {
    id: "cinema-restoration-plan",
    title: "老影院修复计划启动：让银幕重新亮起来",
    excerpt: "首批 30 家老影院将进入修复名单，其中包括多座建于上世纪五十年代的国营影院。",
    category: "热点",
    author: "编辑部 陈见",
    date: "2025-09-21",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20photograph%20of%20an%20old%20single%20screen%20cinema%20facade%20at%20dusk%20with%20warm%20marquee%20bulbs%20and%20weathered%20art%20deco%20details%2C%20deep%20blue%20evening%20sky%2C%20no%20text&width=1200&height=675&seq=news-06&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "计划公布后，社交媒体上最热门的一条留言是：“我小时候在这里看过第一场电影。”对很多人来说，老影院并不只是一个放映场所，而是城市记忆的坐标。",
      },
      {
        type: "p",
        text: "首批修复将优先保留原有的观众厅结构与门头样式，仅在声学与放映设备上进行升级。相关负责人表示，修复不是翻新，而是“让它在原来的位置上继续存在”。",
      },
      { type: "h3", text: "下一步" },
      {
        type: "p",
        text: "名单将在年底前完成评估，部分影院预计明年上半年重新开放，并设置经典影片常设放映单元。",
      },
    ],
    relatedTitleIds: ["summer-screening-room", "harbor-in-fog", "letters-in-april"],
  },
];